module.exports = __webpack_public_path__ + "img/1.5bac0172.png";